import React, { useEffect, useState } from 'react';
import { Card, Button, message, Spin, Typography, Row, Col, Badge, Empty } from 'antd';
import { useNavigate } from 'react-router-dom';
import { getMonthlyTests } from '../../services/testApi';
import type { MonthlyTest } from '../admin/monthly-test/types';
import './MonthlyTests.css';

const { Title, Paragraph } = Typography;

const MonthlyTests: React.FC = () => {
  const [tests, setTests] = useState<MonthlyTest[]>([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const fetchTests = async () => {
    setLoading(true);
    try {
      const data = await getMonthlyTests();
      setTests(data.filter((test: MonthlyTest) => test.isActive));
    } catch (e) {
      message.error('Ошибка при загрузке тестов');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTests();
  }, []);

  return (
    <div style={{ padding: 24, maxWidth: 1200, margin: '0 auto' }}>
      <Title level={2}>Ежемесячное тестирование</Title>
      <Paragraph>
        Здесь вы можете пройти ежемесячные сборные тесты. У вас есть 3 попытки на каждый тест в течение месяца.
      </Paragraph>

      <Spin spinning={loading}>
        {!loading && tests.length === 0 ? (
          <Empty
            description="Новых тестов пока нет"
            style={{ marginTop: 48 }}
          />
        ) : (
        <Row gutter={[16, 16]}>
          {tests.map((test) => (
            <Col key={test.id} xs={24} sm={12} md={8} style={{ display: 'flex' }}>
              <div
                style={{
                  width: '100%',
                  flex: 1,
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                <Badge.Ribbon
                  rootClassName="monthly-test-ribbon-wrap"
                  text="Пройден"
                  color="green"
                  style={{ display: test.isPassed ? undefined : 'none' }}
                >
                  <Card
                    style={{
                      width: '100%',
                      flex: 1,
                      display: 'flex',
                      flexDirection: 'column',
                    }}
                    styles={{
                      body: {
                        flex: 1,
                        display: 'flex',
                        flexDirection: 'column',
                        minHeight: 0,
                      },
                    }}
                    title={test.name}
                    actions={[
                      <Button
                        key="start"
                        type="primary"
                        disabled={(test.attemptsCount ?? 0) >= 3}
                        onClick={() => navigate(`/monthly-test/${test.id}`)}
                      >
                        {(test.attemptsCount ?? 0) >= 3 ? 'Лимит попыток исчерпан' : 'Начать тест'}
                      </Button>,
                    ]}
                  >
                    <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
                      <Paragraph
                        style={{ 
                          marginBottom: 16, 
                          wordBreak: 'break-word', 
                          flex: 1,
                          minHeight: '72px',
                        }}
                      >
                        {test.description}
                      </Paragraph>
                    </div>
                    <div style={{ marginTop: 'auto', flexShrink: 0 }}>
                      <div>
                        <b>Попыток использовано: {test.attemptsCount ?? 0}/3</b>
                      </div>
                      <div>
                        <b>Время на тест: {Math.ceil(Number(test.testTime || 0) / 60)} мин.</b>
                      </div>
                      <div
                        style={{
                          color: '#A40207',
                          marginTop: 4,
                          minHeight: 22,
                          visibility:
                            (test.attemptsCount ?? 0) >= 3 && test.nextAttempt ? 'visible' : 'hidden',
                        }}
                      >
                        Тест заблокирован до: {test.nextAttempt ?? ''}
                      </div>
                    </div>
                  </Card>
                </Badge.Ribbon>
              </div>
            </Col>
          ))}
        </Row>
        )}
      </Spin>
    </div>
  );
};

export default MonthlyTests;
